
  import { mapGetters } from 'vuex'
  import AuthorSlugPageView from '../../components/views/AuthorSlugPageView'

  export default {
    name: 'AuthorPage',
    components: { AuthorSlugPageView },
    async fetch() {
      try {
        await this.$store.dispatch('author/getAuthor', {
          slug: this.$route.params.slug,
        })
        await this.$store.dispatch('author/getAuthorTracks', {
          slug: this.$route.params.slug,
        })
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err)
        this.$nuxt.error({ statusCode: 404, message: 'Автор не найден' })
      }
    },
    head() {
      return {
        title: `${this.authorName}. Лицензионная музыка для бизнеса, видео и других проектов`,
        meta: [
          {
            hid: 'description',
            name: 'description',
            content: `Здесь вы можете купить и скачать лицензионную музыку от ${this.authorName} для видео, рекламы, радио, телевидения, кино, компьютерных игр и заведений. `,
          },
          {
            hid: 'keywords',
            name: 'keywords',
            content: ` ${this.authorName}, купить музыку, скачать музыку, Wav, купить лицензионную музыку, музыка для бизнеса, купить музыку для видео, купить музыку для ютьюб, купить музыку для фильма, купить музыку для игры, купить музыку для заведений, музыка для рекламы, скачать, купить'`,
          },
        ],
      }
    },
    computed: {
      ...mapGetters('author', ['authorName']),
    },
  }
